<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		:max-width="maxWidth"
	>
		<!-- Актіватор -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</slot>
				</template>
				<!-- <span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span> -->
			</v-tooltip>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }} {{ id }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-data-table
					:items="estimates"
					:headers="header.vehicles"
					item-key="id"
					hide-default-footer
					:items-per-page="-1"
				>
					<!-- <template v-slot:item.actions="{ item, index }">
						<v-toolbar flat dense color="transparent">
							<v-icon class="mx-3" @click="removeVehicle(item)">mdi-delete</v-icon>
							<z-detail-vehicle v-model="item" @edit="editVehicle(item, $event)">
								<template v-slot:activator="props">
									<v-icon class="mx-3" v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">mdi-pencil</v-icon>
								</template>
							</z-detail-vehicle>
						</v-toolbar>
					</template> -->
				</v-data-table>
				
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<!-- <v-btn color="success" dark @click.native="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn> -->
			</v-card-actions>
		</v-card>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zDate from '@/views/components/control/Date2'

export default {
	name: 'DialogDetailVehicleParkEstimate',
	//mixins: [mixin],
	components: { zDate },
	data: () => ({
		dialog: false,
		fullscreen: true,
		loading: false,
		/* loadings: {
			type: false,
		}, */

		header: {
			vehicles: [
				{ text: 'ID', value: 'request.id', sortable: true, width: '50'},
				{ text: 'Номер', value: 'request.number', sortable: true},
				{ text: 'VIN', value: 'request.vin', sortable: true},
				{ text: 'Марка', value: 'request.brand.name', sortable: true},
				{ text: 'Модель', value: 'request.model.name', sortable: true},
				{ text: 'Рік випуску', value: 'request.yearProd', sortable: true},
				{ text: 'Тип приводу', value: 'request.driver.name', sortable: true},
				{ text: "Об'єм двигуна", value: 'request.engineVolume', sortable: true},
				{ text: 'Тип палива', value: 'request.fuel.name', sortable: true},
				{ text: 'Коробка передач', value: 'request.gearbox.name', sortable: true},
				{ text: 'Колір', value: 'request.color.name', sortable: true},
				{ text: 'Показник одометра', value: 'request.odometer', sortable: true},
				{ text: 'Середня ціна, UAH', value: 'avgPriceUAH', sortable: true},
				{ text: 'Середня ціна, USD', value: 'avgPriceUSD', sortable: true},
				{ text: '', value: 'actions', sortable: false, width: '10%' },
			],
		},

		item: {},
	}),

	props: {
		title: 				{ type: String, default: 'Оцінка' },
		icon: 				{ type: String, default: 'mdi-ruler-square-compass' },
		maxWidth: 			{ type: Number, default: 600 },
		park: 				{ type: Object, default: () => {} },
		selected: 			{ type: Object, default: null },
	},

	computed: {
		...mapGetters('VehicleParkEstimate', [ 'items' ]),

		id() {
			return this.item?.id ? this.item.id : null
		},

		/* vehicles() {
			if(!this.item?.park) {
				this.$set(this.item, 'park', {})
			}

			if(!this.item?.park?.vehicles) {
				this.$set(this.item.park, 'vehicles', [])
			}

			return this.item.park.vehicles
		}, */

		estimates() {
			return this.item?.estimates ? this.item.estimates : []
		}
	},

	created () {
		//console.log(this.$options.name, 'created')

		//this.$set(this.item, 'date', (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))

		/* if(this.types.length == 0) {
			this.loadings.type = true
			this.loadType().then(() => this.$set(this.item, 'type', this.types[0])).finally(() => (this.loadings.type = false));
		} */
	},

	watch: {
		dialog: function (val) {
			if(val) {
				this.onOpen()
			} else {
				this.onClose()
			}
		},
	},

	methods: {
		//...mapActions('VehicleParkEstimate', [ 'setItem' ]),
		//...mapActions('VehicleParkEstimate', { loadType: 'load'}),
		
		setItem(data) {
			this.item = data
		},
		
		onOpen () {
			console.log('details.mixin.main', 'onOpen','selected', this.selected)

			if(this.data) {
				this.setItem({...this.data})
			} else if(this.selected) {
				this.find(this.selected)
			}
		},

		onClose () {
			//this.setItem()
		},

		onClear() {
			//this.$refs.form.reset()
			//this.clear()

			/* this.item = {
				date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
				type: this.types[0],
				park: { id: this.park.id },
			}; */
		},

		find() {
			let that = this

			console.log(this.$options.name, 'find', 'selected', this.selected)

			if(!this.selected?.id) return;

			return axios.get(`/vehicle/park/estimate/${this.selected.id}`).then(response => {
				console.log(this.$options.name, 'onOK','response.data', response.data)
				//this.$emit('ok', response.data)
				that.setItem(response.data)
			}, error => {
				console.log(error)
			}).finally(() => {
				this.loading = false
			});
		},

		onOK() {
			let that = this

			//console.log(this.$options.name, 'onOK', 'item', this.item)

			/* if(this.$refs.form.validate()) {
				this.loading = true
				axios.post('/vehicle/park/estimate', this.item).then(response => {
					//console.log(this.$options.name, 'onOK','response.data', response.data)
					this.$emit('ok', response.data)
					that.dialog = false
				}, error => {
					console.log(error)
				}).finally(() => {
					this.loading = false
				});
			} */

			/* if(this.$refs.parameters.validate()) {
				if(this.selected) {
					//this.selected = {...this.item}
					this.$emit('edit', {...this.item})
				} else {
					this.$emit('add', {...this.item})
				}

				this.dialog = false
			} */
		},
	},
}
</script>